import { render, staticRenderFns } from "./OverviewStats.vue?vue&type=template&id=40742b86&"
import script from "./OverviewStats.vue?vue&type=script&lang=js&"
export * from "./OverviewStats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports